var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.validate)?_c('p',{staticClass:"text-left",staticStyle:{"color":"#f5222d"}},[_vm._v(" "+_vm._s(_vm.customMsg || _vm.errorMsg)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }